import React from "react";
import ReactPaginate from "react-paginate";
import leftArrow from "../../assets/svg/lar.svg";
import rightArrow from "../../assets/svg/rar.svg";

const CustomPagination = ({ itemsPerPage, setItemsPerPage, pageCount, onPageChange, currentPage }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "24px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span style={{ fontSize: "13px", color: "#212129" }}>Records per page :</span>
        <select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(parseInt(e.target.value))}
          style={{
            padding: "4px 8px",
            borderRadius: "12px",
            border: "1px solid #E5E5E5",
            fontSize: "13px",
            outline: "none",
            backgroundColor: "#FFFFFF",
            cursor: "pointer",
            color: "#172B4D",
            fontWeight: "500",
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      <ReactPaginate previousLabel={<img src={leftArrow} alt="prev" />} nextLabel={<img src={rightArrow} alt="next" />} breakLabel={"..."} pageCount={pageCount} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={onPageChange} containerClassName={"pagination-container"} activeClassName={"active-page"} pageClassName={"page-item"} pageLinkClassName={"page-link"} previousClassName={"page-item"} previousLinkClassName={"page-link"} nextClassName={"page-item"} nextLinkClassName={"page-link"} breakClassName={"page-item"} breakLinkClassName={"page-link"} forcePage={currentPage} />

      <style>
        {`
          .pagination-container {
            display: flex;
            list-style: none;
            gap: 16px;
            padding: 0;
            margin: 0;
            align-items: center;
          }
          .page-item {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .page-link {
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: #172B4D;
            text-decoration: none;
            font-size: 14px;
            font-weight: 600;
            transition: all 0.2s ease;
          }
          .active-page .page-link {
            background-color: #2C8C53;
            color: #FFFFFF;
          }
          .page-item:hover:not(.active-page) .page-link {
            background-color: #F4F5F7;
          }
        `}
      </style>
    </div>
  );
};

export default CustomPagination;
